import { useNavigate } from "react-router-dom";
import PortfolioDataList from "../../Data/PortfolioDataList";
import "./Css/ListData.css";
import { IoCopy, IoSearchSharp } from "react-icons/io5";

export const ListPage = () => {
  const navigate = useNavigate();

  const handleImageClick = (id) => {
    window.scrollTo({ top: 0, behavior: 'auto' });
    navigate(`/portfolio/${id}`);
  };

  return (
    <div className="rounded-[15px] bg-gray-100 overflow-hidden font-sans grid grid-cols-1 min-[550px]:grid-cols-2 lg:grid-cols-3 gap-7 p-4">
      {PortfolioDataList.map((item) => (
        <div
          key={item.id}
          className="hover-img relative overflow-hidden rounded-[20px] p-4 shadow-lg border-[2px] border-gray-300 bg-white transition-all duration-300 hover:shadow-xl"
        >
          <div className="h-full flex flex-col">
            <div
              className="image-container group w-full h-[280px] relative overflow-hidden rounded-[20px] cursor-pointer"
              onClick={() => handleImageClick(item.id)}
            >
              <img
                src={item.src}
                alt={item.alt}
                className="card-image w-full h-full object-cover transition-transform duration-800 group-hover:scale-110 group-hover:rotate-2"
                loading="lazy"
              />
              <div className="icon-overlay absolute inset-0 flex justify-center items-center gap-5 opacity-0 bg-black/70 z-10 transition-opacity duration-600 group-hover:opacity-100">
                <IoSearchSharp
                  className="icon p-3 bg-white text-blue-600 rounded-full transition-all duration-600 hover:bg-blue-600 hover:text-white"
                  size={40}
                />
                <IoCopy
                  className="icon p-3 bg-white text-blue-600 rounded-full transition-all duration-600 hover:bg-blue-600 hover:text-white"
                  size={40}
                />
              </div>
              <div className="dataline-content absolute bottom-10 left-1/2 w-[90%] max-w-[316px] text-white text-center opacity-0 transform -translate-x-1/2 translate-y-full transition-all duration-600 z-20">
                <span className="data-line text-xl font-primary">{item.dataLine}</span>
              </div>
            </div>

            <div className="py-4 flex-grow">
              <h3
                className="font-semibold font-primary text-gray-900 mb-2 text-xl cursor-pointer hover:text-blue-600 transition-colors"
                onClick={() => handleImageClick(item.id)}
              >
                {item.title}
              </h3>
              <p className="text-gray-700 text-base font-primary line-clamp-3">
                {item.description}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
